import ReactDOM from 'react-dom';
import type { ComponentType } from 'react';
import Gallery, { ReactImageGalleryItem } from 'react-image-gallery';
import { Close as CloseIcon } from '@mui/icons-material';
import styled from 'styled-components';
import { IconButton } from '../button';

interface ImageGalleryProps {
  photos: ReactImageGalleryItem[];
  startIndex: number;
  id?: string;
}

const GalleryWrapper = styled.div`
  position: absolute;
  z-index: 1000000;

  & .image-gallery-content {
    display: none;

    &.fullscreen {
      display: grid;
      grid-template-rows: 1fr 7rem;
      grid-template-columns: 100%;
      height: 100%;

      & .image-gallery-swipe {
        display: grid;
        height: 100%;
      }

      & .image-gallery-slides {
        display: grid;
        grid-auto-rows: 1fr;
        align-items: center;
        height: 100%;

        & > .image-gallery-slide {
          align-items: center;
          height: 100%;

          & img {
            position: absolute;
            height: 100%;
          }
        }
      }

      & .image-gallery-thumbnails {
        height: 100%;

        & * {
          height: 100%;
        }

        & .image-gallery-thumbnails-container {
          cursor: initial;

          & > button {
            width: auto;
            cursor: pointer;
          }
        }
      }
    }
  }
`;

const CloseFullScreenButton = styled(IconButton)`
  position: absolute !important;
  top: 1rem;
  right: 1rem;
  height: max-content;
`;

const GalleryComponent = Gallery as unknown as ComponentType<any>;

export const ImageGallery: React.FC<ImageGalleryProps> = ({
  photos,
  id = '',
  ...props
}: ImageGalleryProps) => {
  return ReactDOM.createPortal(
    <GalleryWrapper>
      <GalleryComponent
        items={photos.map((img: any) => ({ original: img, thumbnail: img }))}
        showPlayButton={false}
        useBrowserFullscreen={false}
        renderFullscreenButton={(onClick: () => void, isFullscreen: boolean) => (
          <CloseFullScreenButton
            id={'image-gallery-fullscreen-button' + id}
            className={`image-gallery-icon ${isFullscreen ? '' : 'Closed'}`}
            onClick={onClick}
            iconColor={'--white'}
          >
            <CloseIcon />
          </CloseFullScreenButton>
        )}
        {...props}
      />
    </GalleryWrapper>,
    document.body,
  );
};
